/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_SendInputs */

const th_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่งคำเชิญ`)
};

const en_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send invitation`)
};

const ja_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待を送信`)
};

const zh_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送邀请`)
};

const es_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar invitación`)
};

const pt_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar convite`)
};

const id_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim undangan`)
};

const fr_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer l’invitation`)
};

const tl_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ipadala ang paanyaya`)
};

const vi_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gửi lời mời`)
};

const ko_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초대 보내기`)
};

const de_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladung senden`)
};

const ru_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить приглашение`)
};

const tr_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davet gönder`)
};

const it_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia l'invito`)
};

const pl_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyślij zaproszenie`)
};

const uk_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Надіслати запрошення`)
};

const hi_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निमंत्रण भेजें`)
};

const ar_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إرسال الدعوة`)
};

const ms_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantar jemputan`)
};

const bn_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আমন্ত্রণ পাঠান`)
};

const zh_tw2_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`寄出邀請`)
};

const zh_hk2_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`寄出邀請`)
};

const ur_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دعوت بھیجیں`)
};

const fa_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فرستادن دعوت`)
};

const sw_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuma mwaliko`)
};

const nl_invite_send = /** @type {(inputs: Invite_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitnodiging versturen`)
};

/**
* | output |
* | --- |
* | "Send invitation" |
*
* @param {Invite_SendInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const invite_send = /** @type {((inputs?: Invite_SendInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_SendInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_invite_send(inputs)
	if (locale === "ja") return ja_invite_send(inputs)
	if (locale === "zh") return zh_invite_send(inputs)
	if (locale === "es") return es_invite_send(inputs)
	if (locale === "pt") return pt_invite_send(inputs)
	if (locale === "id") return id_invite_send(inputs)
	if (locale === "fr") return fr_invite_send(inputs)
	if (locale === "tl") return tl_invite_send(inputs)
	if (locale === "vi") return vi_invite_send(inputs)
	if (locale === "ko") return ko_invite_send(inputs)
	if (locale === "de") return de_invite_send(inputs)
	if (locale === "ru") return ru_invite_send(inputs)
	if (locale === "tr") return tr_invite_send(inputs)
	if (locale === "it") return it_invite_send(inputs)
	if (locale === "pl") return pl_invite_send(inputs)
	if (locale === "uk") return uk_invite_send(inputs)
	if (locale === "hi") return hi_invite_send(inputs)
	if (locale === "ar") return ar_invite_send(inputs)
	if (locale === "ms") return ms_invite_send(inputs)
	if (locale === "bn") return bn_invite_send(inputs)
	if (locale === "zh-TW") return zh_tw2_invite_send(inputs)
	if (locale === "zh-HK") return zh_hk2_invite_send(inputs)
	if (locale === "ur") return ur_invite_send(inputs)
	if (locale === "fa") return fa_invite_send(inputs)
	if (locale === "sw") return sw_invite_send(inputs)
	if (locale === "nl") return nl_invite_send(inputs)
	return en_invite_send(inputs)
});